interface props {
  toggle: () => void
}

export const BurgerButton: React.FC<props> = ({ toggle }) => (
  <button id='burger-btn' type='button' className="gm-burger-btn" onClick={toggle} >
    <div id='burger-icon' className='gm-burger-icon' />
  </button >
);